import React from 'react';
import PropTypes from "prop-types";
import PillButton, { VARIANTS } from '../PillButton';
import pdfWhiteIcon from "../../../assets/svg/pdf-icon-white.svg";

const ColoringPageButton = ({ pdfHandler, iconOnly }) => {
    return (
        <PillButton
            variant={VARIANTS.GREEN}
            onClick={pdfHandler}
            icon={<img src={pdfWhiteIcon} alt="" width="20" height="20" />}
            style={{ minWidth: "auto", fontSize: "15px", fontWeight: 500, padding: "6px 14px", backgroundColor: "#6bbc43", color: "#fff" }}
        >
            {!iconOnly && "Coloring Page"}
        </PillButton>
    )
}

ColoringPageButton.propTypes = {
    pdfHandler: PropTypes.func.isRequired,
    size: PropTypes.string,
    iconOnly:  PropTypes.bool,
};

export default ColoringPageButton;